import { useTranslations } from 'next-intl'

type NotificationData = {
  key: string
  message: string
  values?: Record<string, string | number>
  queue_position?: string | number
  queuePosition?: string | number
}

export const useNotificationTranslator = () => {
  const t = useTranslations('notifications')

  return (data: NotificationData): string => {
    if (!data.key || !t.has(data.key)) return data.message

    return t(data.key, {
      ...data.values,
      ...(data.queue_position !== undefined ? { queue_position: data.queue_position } : {}),
      ...(data.queuePosition !== undefined ? { queue_position: data.queuePosition } : {})
    })
  }
}
